<template>
  <div :class="`${appendClass ?? ''} flex flex-col md:flex-row mt-4 items-start gap-2`">
    <span v-if="showMorePreCopy" :class="isDropDownVariant ? 'text-base' : 'text-sm'">{{ showMorePreCopy }}</span>
    <button
      aria-label="Show or hide button"
      type="button"
      class="show-hide flex items-center"
      :class="isDropDownVariant ? 'text-base-bold' : 'text-sm-bold'"
      :disabled="disabled"
      @click="emit('click')"
    >
      {{ buttonLabel }}
      <span
        v-if="buttonLabel.length > 0 && isDropDownVariant"
        class="bg-icon-chevron-down icon w-[12px] h-[7px] ml-2 bg-no-repeat bg-contain"
        :class="showMore ? 'transform rotate-180' : ''"
      ></span>
      <span
        v-if="buttonLabel.length == 0 && isDropDownVariant"
        class="bg-icon-chevron-down-lg icon w-4 h-4 ml-2 bg-no-repeat bg-contain"
        :class="showMore ? 'transform rotate-180' : ''"
      ></span>
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    showMore: boolean;
    disabled?: boolean;
    isDropDownVariant?: boolean;
    showMoreLabel?: string;
    showLessLabel?: string;
    appendClass?: string;
    hideLabel?: boolean;
    showMorePreCopy?: string;
  }>(),
  {
    isDropDownVariant: true,
  }
);

const buttonLabel = computed(() =>
  props.hideLabel ? '' : props.showMore ? (props.showLessLabel ?? 'Show less') : (props.showMoreLabel ?? 'Show more')
);

const emit = defineEmits(['click']);
</script>
